import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import ReactGA from 'react-ga4';
import { App } from './App';
import { COOKIES_CONSENT_KEY } from '@/components';

import './index.css';

ReactGA.gtag('consent', 'default', {
  ad_storage: 'denied',
  ad_user_data: 'denied',
  ad_personalization: 'denied',
  analytics_storage: 'denied',
});

ReactGA.initialize(import.meta.env.VITE_GOOGLE_ANALYTICS_MEASUREMENT_ID as string);

const item = localStorage.getItem(COOKIES_CONSENT_KEY);
if (item) {
  ReactGA.gtag('consent', 'update', { analytics_storage: item });
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
